import { Header1 } from '@/shared/theme/styled-components'
import { useTranslation } from 'react-i18next'

const FormStatusError = ({ statusCode, customMessage }) => {
  const { t } = useTranslation()

  return (
    <>
      {statusCode === 403 && <Header1>{t('subscriptionForm:access_error.unauthorized_access')}</Header1>}
      {statusCode === 404 && <Header1>{t('subscriptionForm:access_error.not_found')}</Header1>}
      {statusCode === 500 && <Header1>{customMessage || t('subscriptionForm:access_error.server_error')}</Header1>}
    </>
  )
}

export default FormStatusError
